import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/assets/images/icons/icon-home.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/icon/FaIcon/FaIcon.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/ui/BreadCrumb/BreadCrumb.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/ui/ArrowLinkButton/ArrowLinkButton.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/app/(default)/about/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/ui/HowToMakeSlider/HowToMakeSlider.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/ui/LoadingLink/LoadingLink.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/ui/RoundArrowIcon/RoundArrowIcon.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/components/ui/SectionTitle/SectionTitle.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src405589514/src/apps/jumplab/src/features/about/components/AboutLp/AboutLp.module.scss");
